module.exports = __webpack_public_path__ + "media/images/vp/icon.delete.gray-52dacf3b4d27c18daf0cb5db1d90430d.svg";